module.exports = __webpack_public_path__ + "img/arrow-right.d8029183.svg";